import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, List, ListItem, ListItemText } from '@mui/material';
import { useAuth } from '../AuthContext';
import { Tenant } from '../types/tenant';
import { getAllTenants } from '../services/tenantService';

interface TenantSwitcherModalProps {
  open: boolean;
  onClose: () => void;
}

const TenantSwitcherModal: React.FC<TenantSwitcherModalProps> = ({ open, onClose }) => {
  const { user, switchTenant, currentTenant } = useAuth();
  const [availableTenants, setAvailableTenants] = useState<Tenant[]>([]);

  const isAdmin = user?.tenants?.some(tenant => tenant.role === 'admin');

  useEffect(() => {
    const fetchTenants = async () => {
      if (isAdmin) {
        try {
          // Fetch all tenants for admin
          const { tenants } = await getAllTenants(1, 200, 'name', 'asc', '');
          setAvailableTenants(tenants);
        } catch (error) {
          console.error('Failed to fetch all tenants for admin:', error);
          // Fallback to user's tenants
          setAvailableTenants(user?.tenants || []);
        }
      } else {
        // Use user's tenants for non-admin
        setAvailableTenants(user?.tenants || []);
      }
    };

    if (open) {
      fetchTenants();
    }
  }, [open, isAdmin, user]);

  const handleTenantSelect = (tenant: Tenant) => {
    switchTenant(tenant);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Switch Tenant</DialogTitle>
      <List sx={{ pt: 0 }}>
        {availableTenants.map((tenant) => (
          <ListItem
            button
            key={tenant.id}
            selected={currentTenant?.id === tenant.id}
            onClick={() => handleTenantSelect(tenant)}
          >
            <ListItemText primary={tenant.name} />
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
};

export default TenantSwitcherModal;
